<div class="actions">
  <app-title-large color="var(--color-neutral-40)" [paddingMobile]="true">{{
    "MyClaims" | translate
  }}</app-title-large>

  <div class="claims-list">
    <ng-container *ngIf="claims?.length; else NoClaimTemplate">
      <app-os-actions-case
        *ngFor="let c of claims"
        [claim]="c"
        [showDetails]="true"
      ></app-os-actions-case>
    </ng-container>

    <ng-template #NoClaimTemplate>
      <div class="spin-container">
        <mat-spinner [mode]="'indeterminate'" diameter="60"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
